import React, {useEffect, useMemo, useState} from 'react';
import { useTranslation } from 'react-i18next';
import Table from '../../tables/Table';

import useCustomTable from '../../tables/useCustomTable';
import * as Format from "../../Format";
import Pagination from "../../tables/Pagination";
import Block from "../../Block";
import {FilterGroup} from "../../FilterButton";
import {TableSearchRow} from "../../tables/TableSearch";

const ConsentByVendorTable = ({data = [], isSuccess, isFetching: isLoading, refetch}) => {

  const { t } = useTranslation();

  const {
    tableProps,
    paginationProps,
    tableSearchProps,
    // tableFilterProps
  } = useCustomTable({
    sortable: true,
    paginate: true,
    sortBy: {name: 'asc'},
  });

  const columns = [{
    Header: t("cmp.analytics.metrics.name"),
    accessor: 'name',
  },{
    Header: t("cmp.analytics.metrics.iabId"),
    accessor: 'iabId',
  },{
    Header: t("cmp.analytics.metrics.devicesWithCmpPresented"),
    accessor: 'devicesWithCmpPresented',
  },{
    Header: t("cmp.analytics.metrics.consentedDevices"),
    accessor: 'consentedDevices',
  },{
    Header: t("cmp.analytics.metrics.consentRate"),
    Cell: ({row}) => <Format.Percent value={row.original.consentRate*100}/>,
    accessor: 'consentRate',
  }
  ];

  const dataToTableRow = (el) => ({
    ...el,
    consentRate: (el.devicesWithCmpPresented || 0) > 0 ? el.consentedDevices/el.devicesWithCmpPresented : 0
  })
  const tableData = useMemo(()=>{
    return data.map((row) => (dataToTableRow(row)))
  }, [data])

  return (
    <>
      <FilterGroup style={{textAlign: "end"}}>
        <TableSearchRow {...tableSearchProps}/>
      </FilterGroup>
      <Block isLoading={isLoading} isSuccess={isSuccess}>
        <Table noPadding data={tableData} columns={columns} {...tableProps} />
      </Block>
      {isSuccess && !isLoading && <Pagination {...paginationProps}/>}
    </>)
}

export default ConsentByVendorTable
